import React from "react";
import { Alert } from "@mui/material";

interface CmsApiErrorAlertProps {
  message?: string;
  errors?: string[];
}

const CmsApiErrorAlert: React.FC<CmsApiErrorAlertProps> = ({
  message,
  errors,
}) => {
  if (!message && !(errors && errors.length)) {
    return null;
  }
  const detail = errors?.length ? errors[0] : null;
  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      {message || "Request failed."}
      {detail && detail !== message ? ` — ${detail}` : null}
    </Alert>
  );
};

export default CmsApiErrorAlert;
